import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/chrome.png'
import _imports_1 from '@/assets/images/safari.png'
import _imports_2 from '@/assets/images/edge.png'
import _imports_3 from '@/assets/images/firefox.png'
import _imports_4 from '@/assets/images/opera.png'
import _imports_5 from '@/assets/images/other.png'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "default-table-area style-two browser-leads" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle border-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 pb-4\"><h3 class=\"mb-0\">Browser Used By Users</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 pe-4 w-auto\" style=\"background-position:right 0 center;color:#64748b !important;\" aria-label=\"Default select example\"><option>July 01 - July 31, 2024</option><option value=\"1\">August 01 - August 31, 2024</option><option selected value=\"2\">September 01 - September 31, 2024</option></select></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "border-bottom" }, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-center bg-transparent"
                }, "Browser"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end bg-transparent"
                }, "Users (%)"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end bg-transparent"
                }, "Sessions"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end bg-transparent"
                }, " Bounce Rate (%) "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end bg-transparent"
                }, " Avg. Session Duration ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "wh-16 rounded-circle",
                        alt: "chrome"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Google Chrome")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("td", { class: "text-end fw-medium" }, "58.4%", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("td", { class: "text-end fw-medium" }, "12,345", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("td", { class: "text-end fw-medium" }, "34.2%", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("td", { class: "text-end fw-medium" }, "3m 15s", -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "wh-16 rounded-circle",
                        alt: "safari"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Safari")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("td", { class: "text-end fw-medium" }, "58.4%", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("td", { class: "text-end fw-medium" }, "12,345", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("td", { class: "text-end fw-medium" }, "34.2%", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("td", { class: "text-end fw-medium" }, "3m 15s", -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "wh-16 rounded-circle",
                        alt: "edge"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Microsoft Edge")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("td", { class: "text-end fw-medium" }, "58.4%", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("td", { class: "text-end fw-medium" }, "12,345", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("td", { class: "text-end fw-medium" }, "34.2%", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("td", { class: "text-end fw-medium" }, "3m 15s", -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "wh-16 rounded-circle",
                        alt: "firefox"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Mozilla Firefox")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("td", { class: "text-end fw-medium" }, "58.4%", -1)),
                _cache[17] || (_cache[17] = _createElementVNode("td", { class: "text-end fw-medium" }, "12,345", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("td", { class: "text-end fw-medium" }, "34.2%", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("td", { class: "text-end fw-medium" }, "3m 15s", -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "wh-16 rounded-circle",
                        alt: "opera"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Opera")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[21] || (_cache[21] = _createElementVNode("td", { class: "text-end fw-medium" }, "58.4%", -1)),
                _cache[22] || (_cache[22] = _createElementVNode("td", { class: "text-end fw-medium" }, "12,345", -1)),
                _cache[23] || (_cache[23] = _createElementVNode("td", { class: "text-end fw-medium" }, "34.2%", -1)),
                _cache[24] || (_cache[24] = _createElementVNode("td", { class: "text-end fw-medium" }, "3m 15s", -1))
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createElementVNode("img", {
                        src: _imports_5,
                        class: "wh-16 rounded-circle",
                        alt: "other"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Other")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[26] || (_cache[26] = _createElementVNode("td", { class: "text-end fw-medium" }, "58.4%", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("td", { class: "text-end fw-medium" }, "12,345", -1)),
                _cache[28] || (_cache[28] = _createElementVNode("td", { class: "text-end fw-medium" }, "34.2%", -1)),
                _cache[29] || (_cache[29] = _createElementVNode("td", { class: "text-end fw-medium" }, "3m 15s", -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}